import { EARTHQUAKE_METRICS } from '../../../../../mockData/EarthquakeMetrics.js';
import { PerilMetrics } from '../../../../shared/PerilMetrics.jsx';

export function EarthquakeMetrics() {
  return <PerilMetrics data={EARTHQUAKE_METRICS} tableClasses="mmi-badge" />;
}
